import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { socialClicked } from '../redux/actions/gtmActions'
// import Newsletter from './Newsletter'

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      doc: null
    }
  }

  componentWillMount() {
    this.findFooter(this.props)
  }
  componentWillReceiveProps(props) {
    this.findFooter(props)
  }

  findFooter(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'footer') 

      this.setState({doc})
    }
  }

  handleSocialClick = social => {
    this.props.socialClicked(social)
  }

  render() {
    if(this.state.doc) {
      let {
        prismicCtx,
      } = this.props
      const document = this.state.doc.data
      // console.log(document)
      return (
        <footer id="footer" className={`footer`}>
          <div className="footer-bg"></div>
          <div className="container footer-columns">
            <div className="flexbox">
              {
                document.body.map((slice, index) => {
                  // Locator Column
                  if(slice.slice_type === 'locator_column') {
                    return (
                      <div key={index} className="flex-item half footer-column footer-column-locator">
                        <div className="column-content">
                          {PrismicReact.RichText.render(slice.primary.column_title)}
                          {PrismicReact.RichText.render(slice.primary.description)}
                          <Link to={PrismicReact.Link.url(slice.primary.cta_link, prismicCtx.linkResolver)} className="button button-large">{slice.primary.cta_name}</Link>
                        </div>
                      </div>
                    )
                  }

                  // Follow Column
                  if(slice.slice_type === 'follow_column') {
                    return (
                      <div key={index} className="flex-item half footer-column footer-column-follow">
                        <div className="column-content">
                          {PrismicReact.RichText.render(slice.primary.column_title)}
                          {PrismicReact.RichText.render(slice.primary.description)}
                          <ul className="flexbox">{
                            slice.items.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <a 
                                      href={PrismicReact.Link.url(item.social_media_link, prismicCtx.linkResolver)} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                      onClick={ () => this.handleSocialClick(item.social_media_name) }
                                    >
                                      <img src={item.icon.url} alt={item.social_media_name}/>
                                    </a>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        </div>
                      </div>
                    )
                  }
                })
              }
            </div>
          </div>

          <div className="footer-bar">
            <div className="container">
              <div className="flexbox ">
                <div className="flex-item third">
                  <p className="copyright">{document.copyright}</p>
                </div>
                <div className="flex-item third">
                  <p>{document.message}</p>
                </div>
                <div className="flex-item third">
                  <ul className="flexbox policy-group">
                    {
                      document.policy_items.map((item, index) => {
                        return (
                          <li key={index}>
                            <Link to={PrismicReact.Link.url(item.link, prismicCtx.linkResolver)}>{item.name}</Link>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )
    }
    return <div></div>
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { 
      socialClicked: socialClicked, 
    },
    dispatch
  )


export default connect(mapStateToProps, mapDispatchToProps)(Footer)


// WEBPACK FOOTER //
// ./src/components/Footer.js